import * as React from "react";
import Nlink from "next/link";
import Image from "next/legacy/image";
import { makeStyles } from "@mui/styles"; // TODO remove this deps asap (from package.json)
import {
    AppBar,
    Button,
    Container,
    Grid,
    Link,
    Theme,
    Toolbar,
} from "@mui/material";

const useStyles = makeStyles<Theme>((theme) => ({
    "@global": {
        ul: {
            margin: 0,
            padding: 0,
            listStyle: "none",
        },
        li: {
            marginBottom: theme.spacing(2),
        },
    },
    appBar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(4),
        paddingTop: theme.spacing(1),
    },
    toolbar: {
        flexWrap: "wrap",
    },
    toolbarTitle: {
        flexGrow: 1,
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },
    link: {
        padding: theme.spacing(1, 1.5),
    },
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
        },
    },
}));

interface Props {
    children: React.ReactNode;
}

const Layout = (props: Props) => {
    const classes = useStyles();

    return (
        <>
            <AppBar
                position="static"
                color="inherit"
                elevation={0}
                className={classes.appBar}
            >
                <Toolbar className={classes.toolbar}>
                    <Nlink href={"/"} passHref>
                        <Link className={classes.toolbarTitle}>
                            <Image
                                width={170}
                                height={135}
                                src={"/senzacni/logo.png"}
                                alt={"senZAČNI BĚH 2021"}
                            />
                        </Link>
                    </Nlink>
                    <nav>
                        <Nlink href={"/registrace"} passHref>
                            <Button variant="outlined" className={classes.link}>
                                Registrace
                            </Button>
                        </Nlink>
                        <Nlink href={"/podminky"} passHref>
                            <Link
                                variant="button"
                                color="text.primary"
                                className={classes.link}
                            >
                                Podmínky&nbsp;soutěže
                            </Link>
                        </Nlink>
                        <Nlink href={"/zebricek"} passHref>
                            <Link
                                variant="button"
                                color="text.primary"
                                className={classes.link}
                            >
                                Průběžné&nbsp;pořadí
                            </Link>
                        </Nlink>
                        <Link
                            target={"_blank"}
                            href={"https://www.facebook.com/senzacnibeh"}
                            variant="button"
                            color="text.primary"
                            className={classes.link}
                        >
                            Facebook&nbsp;závodu
                        </Link>
                    </nav>
                </Toolbar>
            </AppBar>
            {props.children}
            {/* Footer */}
            <Container
                maxWidth="md"
                component="footer"
                className={classes.footer}
            >
                <Grid container spacing={4} justifyContent="space-evenly">
                    {footers.map((footer) => (
                        <Grid item key={footer.label}>
                            <Image
                                src={"/senzacni/" + footer.fileName}
                                alt={footer.label}
                                height={80}
                                width={70}
                                title={footer.label}
                            />
                        </Grid>
                    ))}
                </Grid>
                {/*<Copyright sx={{ mt: 5 }} />*/}
            </Container>
            {/* End footer */}
        </>
    );
};

export default Layout;

interface PlaceLogo {
    fileName: string;
    label: string;
}

const footers: Array<PlaceLogo> = [
    { fileName: "bela.png", label: "Bělá pod Pradědem" },
    { fileName: "ceskaVes.png", label: "Česká Ves" },
    { fileName: "jesenik.png", label: "Jeseník" },
    { fileName: "lipovaLazne.png", label: "Lipová lázně" },
    { fileName: "ostruzna.png", label: "Ostružná" },
];

// function Copyright(props: any) {
//     return (
//         <Typography
//             variant="body2"
//             color="text.secondary"
//             align="center"
//             {...props}
//         >
//             <Link color="inherit" href="https://xathlo.cz/">
//                 XATHLO.CZ
//             </Link>{" "}
//             {new Date().getFullYear()}
//         </Typography>
//     );
// }
